import { render, staticRenderFns } from "./ModalTambahMemberComponent.vue?vue&type=template&id=a9294d1c"
import script from "./ModalTambahMemberComponent.vue?vue&type=script&lang=js"
export * from "./ModalTambahMemberComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports